import axiosClient from "./axiosClient";

export const getFeedback = async (params = {}) => {
  const res = await axiosClient.get("/feedback/", { params });
  return res.data;
};

export const getFeedbackStats = async () => {
  const res = await axiosClient.get("/feedback/stats/");
  return res.data;
};

export const createFeedback = async (data) => {
  const res = await axiosClient.post("/feedback/create/", data);
  return res.data;
};

export const updateFeedback = async (feedbackId, data) => {
  const res = await axiosClient.put(`/feedback/${feedbackId}/update/`, data);
  return res.data;
};

export const getFeedbackComments = async (feedbackId) => {
  const res = await axiosClient.get(`/feedback/${feedbackId}/comments/`);
  return res.data;
};

export const createFeedbackComment = async (feedbackId, data) => {
  const res = await axiosClient.post(`/feedback/${feedbackId}/comments/create/`, data);
  return res.data;
};

export const getFeedbackDocuments = async (feedbackId, params = {}) => {
  const res = await axiosClient.get(`/feedback/${feedbackId}/documents/`, { params });
  return res.data;
};

export const uploadFeedbackDocument = async (feedbackId, file, commentText = "") => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("comment_text", commentText);
  const res = await axiosClient.post(`/feedback/${feedbackId}/documents/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateFeedbackDocument = async (feedbackId, documentId, data) => {
  const res = await axiosClient.put(`/feedback/${feedbackId}/documents/${documentId}/`, data);
  return res.data;
};

export const deleteFeedbackDocument = async (feedbackId, documentId) => {
  const res = await axiosClient.delete(`/feedback/${feedbackId}/documents/${documentId}/`);
  return res.data;
};
